import { Components } from 'Lib';

const {
  AdvancedDataTableComponents,
  AppLayout,
  Buttons,
  DataTableComponents,
  DetailPanel,
  DetailTable,
  EditableDetailPanel,
  FloatingActionMenu,
  HSCDates,
  HSCInput,
  HSCMultiselect,
  HSCSelect,
  UserSelect,
  HSCTooltip,
  HSCPopover,
  Misc,
  NoteCard,
  NotesListPanel,
  StatusSelect,
} = Components;

const { DateInput, DateRangeInput } = HSCDates;

const {
  ErrorMessage,
  HSCCard,
  HSCIcon,
  HSCIconAndLabel,
  HSCNoWrapText,
  NoContentBox,
  StatusLabel,
  BooleanAndNotesComponent,
  ContentWithNotesComponent,
} = Misc;

export {
  AdvancedDataTableComponents,
  Buttons,
  DataTableComponents,
  FloatingActionMenu,
  DetailPanel,
  DetailTable,
  EditableDetailPanel,
  DateInput,
  DateRangeInput,
  HSCCard,
  HSCInput,
  HSCSelect,
  UserSelect,
  StatusSelect,
  HSCMultiselect,
  NoteCard,
  NotesListPanel,
  BooleanAndNotesComponent,
  ContentWithNotesComponent,
  ErrorMessage,
  HSCIcon,
  HSCIconAndLabel,
  HSCNoWrapText,
  HSCTooltip,
  HSCPopover,
  NoContentBox,
  StatusLabel,
  AppLayout,
};
